import { serviceTypes } from './serviceTypes';
import { GEOGRAPHICAL_MAP } from 'utils/constants/Map';
import { SITE_POLICY_DEFAULT_VALUES } from 'utils/constants/visitor';
import { TASK_MODEL } from 'services/entity/task';

export const TASK_TYPE = {
  MAINTENANCE: {
    id: serviceTypes.maintenance,
    mapIcon: 'MAINTENANCE_TASK',
    name: 'WorkOrders',

    subtasks: {
      mapIcon: 'MAINTENANCE_SUBTASK',
    },

    map: {
      polyline: {
        strokeColor: '#bbbec0', // pending colour codes
        strokeWeight: 5,
        dashed: true,
      },
    },
  },
  SECURITY: {
    id: serviceTypes.security,
    mapIcon: 'SECURITY',
    name: 'Security',

    subtasks: {
      mapIcon: 'SECURITY_SUBTASK',
    },

    map: {
      polyline: {
        strokeColor: '#bbbec0', // pending colour codes
        strokeWeight: 5,
        dashed: true,
      },
    },
  },
  CLEANING: {
    id: serviceTypes.cleaning,
    mapIcon: 'CLEANING_TASK',
    name: 'Cleaning',

    subtasks: {
      mapIcon: 'CLEANER_SUBTASK',
    },

    map: {
      polyline: {
        strokeColor: '#bbbec0',
        strokeWeight: 5,
        dashed: true,
      },
    },
  },
  PATROL_CHECKPOINT_TASK: {
    id: 'PATROL_CHECKPOINT_TASK',
    mapIcon: 'PATROL_CHECKPOINT_TASK',
    name: 'Patrol Checkpoint',
  },
  PATROL_SINGLE_SITE: {
    id: 'PATROL_SINGLE_SITE',
    name: 'Patrol Single Site',
  },
  PATROL_MULTISITE: {
    id: 'PATROL_MULTISITE',
    name: 'Patrol Multi site',
  },
  TRANSPORT_STANDARD: {
    id: 'TRANSPORT_STANDARD',
    name: 'Transport Standard',
  },
};

export const TASK_EVIDENCE_TYPE = {
  CHECKBOX: {
    id: 'CHECKBOX',
    name: 'Checkbox',
  },
  IMAGE: {
    id: 'IMAGE',
    name: 'Image',
  },
  AUDIO: {
    id: 'AUDIO',
    name: 'Audio',
  },
  DESCRIPTION: {
    id: 'DESCRIPTION',
    name: 'Description',
  },
  NUMERIC: {
    id: 'NUMERIC',
    name: 'Number',
  },
  QRCODE: {
    id: 'QRCODE',
    name: 'QR Code',
  },
  VIDEO: {
    id: 'VIDEO',
    name: 'Video',
  },
  OPTION_SINGLE: {
    id: 'OPTION_SINGLE',
    name: 'Single Select',
  },
  OPTION_MULTIPLE: {
    id: 'OPTION_MULTIPLE',
    name: 'Multiselect',
  },
  SIGNATURE: {
    id: 'SIGNATURE',
    name: 'Signature',
  },
};

export const AVAILABLE_EVIDENCE = [
  TASK_EVIDENCE_TYPE.AUDIO,
  // TASK_EVIDENCE_TYPE.CHECKBOX,
  TASK_EVIDENCE_TYPE.DESCRIPTION,
  TASK_EVIDENCE_TYPE.IMAGE,
  //TASK_EVIDENCE_TYPE.QRCODE,
  TASK_EVIDENCE_TYPE.NUMERIC,
  TASK_EVIDENCE_TYPE.OPTION_SINGLE,
  TASK_EVIDENCE_TYPE.OPTION_MULTIPLE,
  TASK_EVIDENCE_TYPE.SIGNATURE,
];
export const PATROL_AVAILABLE_EVIDENCE = [
  TASK_EVIDENCE_TYPE.AUDIO,
  TASK_EVIDENCE_TYPE.CHECKBOX,
  TASK_EVIDENCE_TYPE.DESCRIPTION,
  TASK_EVIDENCE_TYPE.IMAGE,
  //TASK_EVIDENCE_TYPE.QRCODE,
  TASK_EVIDENCE_TYPE.NUMERIC,
  TASK_EVIDENCE_TYPE.OPTION_SINGLE,
  TASK_EVIDENCE_TYPE.OPTION_MULTIPLE,
  TASK_EVIDENCE_TYPE.SIGNATURE,
];

export const TASK_STATUS = {
  NEW: { id: 'NEW', name: 'New' },
  IN_PROGRESS: { id: 'IN_PROGRESS', name: 'In-Progress' },
  RESOLVED_COMPLETE: {
    id: 'RESOLVED_COMPLETE',
    name: 'Completed',
  },
  RESOLVED_INCOMPLETE: {
    id: 'RESOLVED_INCOMPLETE',
    name: 'Incomplete',
  },
  RESOLVED_ABORTED: { id: 'RESOLVED_ABORTED', name: 'Aborted' },
};
export const TASK_STATUS_FILTERS = [
  {
    id: TASK_STATUS.NEW.id,
    name: TASK_STATUS.NEW.name,
  },
  {
    id: TASK_STATUS.IN_PROGRESS.id,
    name: TASK_STATUS.IN_PROGRESS.name,
  },
  {
    id: TASK_STATUS.RESOLVED_COMPLETE.id,
    name: TASK_STATUS.RESOLVED_COMPLETE.name,
  },
  {
    id: TASK_STATUS.RESOLVED_INCOMPLETE.id,
    name: TASK_STATUS.RESOLVED_INCOMPLETE.name,
  },
  {
    id: TASK_STATUS.RESOLVED_ABORTED.id,
    name: TASK_STATUS.RESOLVED_ABORTED.name,
  },
];

export const REPORTING_TASK_STATUS_FILTERS = [
  {
    id: TASK_STATUS.IN_PROGRESS.id,
    name: TASK_STATUS.IN_PROGRESS.name,
  },
  {
    id: TASK_STATUS.RESOLVED_COMPLETE.id,
    name: TASK_STATUS.RESOLVED_COMPLETE.name,
  },
  {
    id: TASK_STATUS.RESOLVED_INCOMPLETE.id,
    name: TASK_STATUS.RESOLVED_INCOMPLETE.name,
  },
  {
    id: TASK_STATUS.RESOLVED_ABORTED.id,
    name: TASK_STATUS.RESOLVED_ABORTED.name,
  },
];

export const EVIDENCE_PREFIX = 'ev';

export const TASK_DEFAULT = {
  isTemplate: true,
  wrapsId: null,
  scanCode: null,
  scanAutoStart: null,
  scanStartOnly: null,
  surfaceViewPreferred: true,
  status: TASK_STATUS.NEW.id,
  taskName: '',
  siteSurfaceImages: GEOGRAPHICAL_MAP,
  newBusinessClient: false,
  severityRating: 'NOT_RATED',
  ...SITE_POLICY_DEFAULT_VALUES,
};

export const SUBTASK_DEFAULT = {
  isTemplate: false,
  wrapsId: null,
  scanCode: null,
  scanAutoStart: null,
  scanStartOnly: null,
  surfaceViewPreferred: true,
  status: TASK_STATUS.NEW.id,
  siteSurfaceImages: GEOGRAPHICAL_MAP,
};

export const TaskPlaceholder = {
  checkboxDescription: 'placeholder_checklist_item_description',
  evidenceDescription: 'Enter the description for the evidence.',
  description: 'Enter the description for the task.',
};

export const formatTaskCategoryName = taskType => {
  switch (taskType) {
    case serviceTypes.maintenance:
      return TASK_TYPE.MAINTENANCE.name;
    case serviceTypes.cleaning:
      return TASK_TYPE.CLEANING.name;
    case serviceTypes.patrolCheckPointTask:
      return TASK_TYPE.PATROL_CHECKPOINT_TASK.name;
    default:
      return '-';
  }
};
export const TASK_TYPE_FILTER = [
  {
    id: TASK_TYPE.CLEANING.id,
    name: TASK_TYPE.CLEANING.name,
  },
  {
    id: TASK_TYPE.MAINTENANCE.id,
    name: TASK_TYPE.MAINTENANCE.name,
  },
];
export const TASK_SCHEDULE_LABELS = {
  timezone: 'Time Zone',
  dailyInterval: 'task_schedule_daily_interval',
  startTime: 'Start Time',
  startDate: 'Start Date',
  repeatUntil: 'Repeat Until',
  finishTime: 'Finish Time',
  expectedDuration: 'Expected Duration',
  repeatsEvery: 'Repeats Every',
  everyDay: 'Everyday',
  days: 'Days',
  allDay: 'All Day',
  rescheduleWeekends: 'Reschedule weekends',
  rescheduleInvalidDates: 'Reschedule invalid dates',
  dateOfMonth: 'Date of Month',
  dayOfMonth: 'Day of Month',
  interval: 'Interval',
  weekly: 'Weekly',
  simpleInterval: 'Simple Interval',
  onceOff: 'Once Off',
};

export const TASK_SCHEDULE_TABLE_HEADERS = {
  Type: 'Type',
  Assignee: 'Assignee',
  StartAfter: 'Start After',
  FinishBefore: 'Finish Before',
  Days: 'Days',
  StartTime: 'Start Time',
  EndTime: 'End Time',
  StartDate: 'Start Date',
  RepeatUntil: 'Repeat Until',
  RepeatsEvery: 'Repeats Every',
  Interval: 'Interval',
  TimeZone: 'Time Zone',
  DateOfMonth: 'Date Of Month',
  RescheduleInvalidDates: 'Reschedule Invalid Dates',
  RescheduleWeekends: 'Reschedule weekends',
  DayOfMonth: 'Day Of Month',
};

export const UN_EDITABLE_TASK_STATUS = [TASK_STATUS.IN_PROGRESS.id, 'RESOLVED'];
export const UN_ASSIGNABLE_TASK_STATUS = ['RESOLVED'];

export const FollowupTaskTableHeaders = [
  {
    headerName: TASK_MODEL.taskType.label,
    field: TASK_MODEL.taskType.id,
  },
  {
    headerName: TASK_MODEL.taskName.label,
    field: TASK_MODEL.taskName.id,
  },
  {
    headerName: TASK_MODEL.status.label,
    field: TASK_MODEL.status.id,
  },
  {
    headerName: TASK_MODEL.description.label,
    field: TASK_MODEL.description.id,
  },
  {
    headerName: TASK_MODEL.numEvidence.label,
    field: TASK_MODEL.numEvidence.id,
  },
];
